<template>
  <v-dialog
    v-model="OpenDialogShowNotes"
    persistent
    max-width="700"
    :scrollable="true"
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            <v-row>
              <v-col cols="1">
                <v-icon :size="30" color="#b11f1f" aria-label="Notes icon">
                  mdi-book-multiple
                </v-icon>
              </v-col>
              <v-col cols="9">
                <span>
                  Notas
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2"
            style="text-align: end; cursor: pointer;"
            @click="closeModal"
          >
            <v-icon left color="#b11f1f">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="height: 400px;">
        <v-container>
          <v-row>
            <v-col cols="10">
              <v-text-field
                class="share-bar-clase"
                label="Buscar"
                outlined
                background-color="#fcf2f2"
                dense
                prepend-inner-icon="mdi-magnify"
                :light="true"
                v-model="filtro"
              ></v-text-field>
            </v-col>
            <v-col
              cols="2"
              style="text-align: end; cursor: pointer;"
              @click="openCreateModal"
            >
              <v-icon right dense :size="25" color="#b11f1f">
                mdi-plus-circle-outline
              </v-icon>
            </v-col>
          </v-row>
          <v-expansion-panels
            class="pb-5"
            v-for="(nota, idx) in showNotes"
            :key="idx"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ nota.formatData || nota.nombre }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <h4>
                  Descripción:
                </h4>
                <div>
                  {{ nota.nota || nota.detalle }}
                </div>
                <v-row class="pt-4">
                  <v-col cols="12">
                    <h4>
                      Creado por: {{ nota.creadoPor }} el: {{ nota.fechaCreacion }}
                    </h4>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
      <v-card-actions style="justify-content: center;">
        <div
          style="display: flex; justify-content: center; align-items: center;"
        >
          <v-pagination
            v-model="page"
            :length="pages"
            circle
          ></v-pagination>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  components: {},
  props: {
    OpenDialogShowNotes: {
      type: Boolean,
      default: false,
    },
    notas: Array,
  },

  data() {
    return {
      requiredRule: [(v) => !!v || "El campo es requerido"],
      data: {
        nombre: null,
        enviarPorCorreo: false,
        nota: null,
        tipo: "Nota",
        tipo_documento: null,
      },
      run: false,
      formData: null,
      page: 1,
      limit: 5,
      filtro: null,
    };
  },

  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    openCreateModal() {
      this.$emit("openCreateModal");
    },
  },
  computed: {
    pages() {
      const totalPages = Math.ceil(this.notasFiltradas.length / this.limit);
      return totalPages < 1 ? 1 : totalPages;
    },
    notasFiltradas() {
      if (!this.filtro) {
        return this.notas;
      }
      const filtroMin = this.filtro.toLowerCase().trim();
      return this.notas.filter((nota) => {
        return nota.nota.toLowerCase().includes(filtroMin);
      });
    },
    indiceInicio() {
      return (this.page - 1) * this.limit;
    },
    indiceFinal() {
      return this.page * this.limit - 1;
    },
    showNotes() {
      return this.notasFiltradas.slice(this.indiceInicio, this.indiceFinal + 1);
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  background-color: rgb(165, 55, 238);
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 5px !important;
  background-color: #fcf2f2;
}
.v-expansion-panel-header {
  background-color: #fcf2f2;
  border-radius: 5px;
}


</style>
